import gql from 'graphql-tag';
import { companyDefaultFragment, companyFragment } from './fragments';

/*
*
*/
export const companies = gql`
  query companies($where: CompanyWhereInput, $orderBy: CompanyOrderByInput, $skip: Int, $after: String, $before: String, $first: Int, $last: Int) {
    companies(where: $where, orderBy: $orderBy, skip: $skip, after: $after, before: $before, first: $first, last: $last) ${companyFragment}
  }
`;

export const companyDefault = gql`
  query companies($where: CompanyWhereInput, $orderBy: CompanyOrderByInput, $skip: Int, $after: String, $before: String, $first: Int, $last: Int) {
    companies(where: $where, orderBy: $orderBy, skip: $skip, after: $after, before: $before, first: $first, last: $last) ${companyDefaultFragment}
  }
`;

export const companyForList = gql`
  query companies($where: CompanyWhereInput, $orderBy: CompanyOrderByInput, $skip: Int, $after: String, $before: String, $first: Int, $last: Int) {
    companies(where: $where, orderBy: $orderBy, skip: $skip, after: $after, before: $before, first: $first, last: $last) {
      id name
    }
  }
`;